export const environment = {
  production: false,
  terminalBeforeOfflineIntervalInMillis: 180000,
  API_URL: 'https://tranquil-savannah-30352.herokuapp.com/' // 'https://rateme-13279.appspot.com/'
  // API_URL: 'http://localhost:8080/'
};
